/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { genericInputSearchOnPages } from '../../store/Document/documentActions';
import ComparisonDocument from './ComparisonDocument';
import ComparisonTags from './ComparisonTags';
import ComparisonSearch from './ComparisonSearch';
import CloseButton from '../Buttons/CloseButton';
import './style.scoped.scss';
import { pageHasContent } from '../../assets/constants/strings';
import { getPagesByDocumentID } from '../../services/axios';
import Loader from '../Loader';

const Comparison = ({
  leftDocument: leftDoc,
  rightDocument: rightDoc,
  // performance test
  clientPages = null,
  handleCloseComparison,
  spKey,
}) => {
  const [leftDocument, setLeftDocument] = useState(leftDoc);
  const [rightDocument, setRightDocument] = useState(rightDoc);

  const [isLoading, setIsLoading] = useState(false);

  const [activeTerm, setActiveTerm] = useState(null);

  const [allPages, setAllPages] = useState([]);
  const [availablePages, setAvailablePages] = useState([]);

  const handleComparisonData = async () => {
    try {
      setIsLoading(true);
      // need to fetch the pages for both documents
      let allAvailablePages = [];

      // populating left doc
      // if left doc already has pages
      if (leftDoc.pages && leftDoc.pages.length > 0) {
        // add pages with content to available array
        allAvailablePages.push(...leftDoc.pages.filter(
          (page) => pageHasContent(page.HTMLContent)
        ));
        setLeftDocument(leftDoc);
      }
      // if the store has them
      else if (
        clientPages &&
        clientPages.filter((page) => page.documentId === leftDoc.id).length > 0
      ) {
        // push all pages that have content
        const leftPages = clientPages.filter(
          (page) => (
            page.documentId === leftDoc.id && pageHasContent(page.HTMLContent)
          )
        );
        // add pages to available array
        allAvailablePages.push(...leftPages);
        // add pages to left document in state
        setLeftDocument({ ...leftDoc, pages: leftPages });
      }
      // no pages available in store
      else {
        // fetch them with api
        let leftPages = await getPagesByDocumentID(leftDoc.id, leftDoc.slug, spKey);

        // remove pages that dont have content
        leftPages = leftPages.filter(
          (page) => pageHasContent(page.HTMLContent)
        );
        // add pages to available array
        allAvailablePages.push(...leftPages);
        // add pages to left document in state
        setLeftDocument({ ...leftDoc, pages: leftPages });
      }

      // populating right doc
      // if right doc already has pages
      if (rightDoc.pages && rightDoc.pages.length > 0) {
        // add pages with content to available array
        allAvailablePages.push(...rightDoc.pages.filter(
          (page) => pageHasContent(page.HTMLContent)
        ));
        setRightDocument(rightDoc);
      }
      // if the store has them
      else if (
        clientPages &&
        clientPages.filter((page) => page.documentId === rightDoc.id).length > 0
      ) {
        // push all pages that have content
        const rightPages = clientPages.filter(
          (page) => (
            page.documentId === rightDoc.id && pageHasContent(page.HTMLContent)
          )
        );
        // add pages to available array
        allAvailablePages.push(...rightPages);
        // add pages to right document in state
        setRightDocument({ ...rightDoc, pages: rightPages });
      }
      // no pages available in store
      else {
        // fetch them with api
        let rightPages = await getPagesByDocumentID(rightDoc.id, rightDoc.slug, spKey)

        // remove pages that dont have content
        rightPages = rightPages.filter(
          (page) => pageHasContent(page.HTMLContent)
        );
        // add pages to available array
        allAvailablePages.push(...rightPages);
        // add pages to right document in state
        setRightDocument({ ...rightDoc, pages: rightPages });
      }
      setAllPages(allAvailablePages);

      setAvailablePages(allAvailablePages);

      // versioning comparison
      if (leftDoc.newVersionId || rightDoc.newVersionId) {
        document.title = 'Comparing Versions of ' + leftDoc.title;
      }
      // regular comparison
      else {
        document.title = 'Comparing ' + leftDoc.title + ' to ' + rightDoc.title;
      }

      setIsLoading(false);
    } catch (e) {
      console.log('error', e);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (leftDoc && rightDoc && !isLoading) handleComparisonData();
  }, [leftDoc, rightDoc, clientPages]);

  const searchTerm = async (input) => {
    setActiveTerm(input);
    setAvailablePages(await genericInputSearchOnPages(input, allPages, true));
  };

  const handleClearActiveTerm = () => {
    setActiveTerm(null);
    setAvailablePages(allPages);
  };

  return (
    <React.Fragment>
      {leftDocument && leftDocument.pages && rightDocument && rightDocument.pages && !isLoading ? (
        <div className="col my-0 px-0 comparison-wrapper">
          <div className="d-flex justify-content-end mb-3">
            <div className="col-2 px-0">
              <ComparisonSearch handleSearch={searchTerm} />
            </div>
            <div className="col-5 px-0">
              <h2 id="close-comparison">
                <CloseButton handleClose={handleCloseComparison} title="Return to Document" />
              </h2>
            </div>
          </div>
          <div className="row">
            <div id="left-comparison-document" className="col-lg-5 px-0">
              <ComparisonDocument
                filteredPages={availablePages.filter((page) => page.documentId === leftDocument.id)}
                document={leftDocument}
                handleTagSelected={searchTerm}
              />
            </div>
            <div id="comparison-tags" className="col-lg-2">
              <ComparisonTags
                allPages={allPages}
                handleTagSelected={searchTerm}
                leftID={leftDocument.id}
                rightID={rightDocument.id}
              />

              <div className="col">
                {activeTerm !== null ? (
                  <div className="text-center">
                    <div className="d-flex my-3 align-items-center">
                      <h4 className="m-0 heading-override d-flex justify-content-between align-items-center w-100">
                        <div>Active {activeTerm && activeTerm.match(/\s/g) ? 'Terms' : 'Term'}</div>
                        <CloseButton handleClose={handleClearActiveTerm} />
                      </h4>
                    </div>
                    <mark id="active-tag">{activeTerm}</mark>
                  </div>
                ) : null}
              </div>
            </div>
            <div id="right-comparison-document" className="col-lg-5 px-0">
              <ComparisonDocument
                filteredPages={availablePages.filter(
                  (page) => page.documentId === rightDocument.id
                )}
                document={rightDocument}
                handleTagSelected={searchTerm}
                hasLink
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="inner-load">
          <Loader text="Assembling Comparison..." />
        </div>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  // clientPages: state.client.pages,
  spKey: state.user.user.spKey
});

// const mapDispatchToProps = { search };

const connector = connect(mapStateToProps, null);

export default connector(Comparison);
